module.exports = __webpack_public_path__ + "static/img/15.792459c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carruDepto/15.jpg
// module id = MkXm
// module chunks = 5